const primary = {
  25: '#FBFDFF',
  50: '#EFF7FF',
  100: '#DEEFFF',
  200: '#B6E0FF',
  300: '#76C8FF',
  400: '#2DADFF',
  500: '#0293F5',
  600: '#0073D2',
  700: '#005CAA',
  800: '#004B87',
  900: '#04294D',
};
export default primary;